<template>
<div id="app" class="m-login">
  <back-home></back-home>
  <header>
    <img :src="config.logo | protocolFixer" alt="" />
    <p>{{config.title}}</p>
  </header>
  <form class="m-loginForm" name="loginForm">
    <mini-tabs :tabs="loginTypes" v-model="loginType" class="tabs"></mini-tabs>
    <div class="item">
      <lg-selects :selects="selects" v-model="area" class="select select-short"></lg-selects>
      <input type="text" placeholder="请输入手机号" name="phone" v-model="phone" class="input-short" v-validate:required v-validate:pattern="phoneRegex" />
      <p class="tip" v-if="phoneError">{{phoneError}}</p>
    </div>
    <div class="item" v-show="loginType === 'password'">
      <input type="password" placeholder="请输入密码" name="password" v-model="password" v-validate:required />
      <p class="tip" v-if="passwordError">{{passwordError}}</p>
    </div>
    <div class="item" v-show="loginType === 'code'">
      <input type="text" placeholder="请输入验证码" name="code" v-model="code" v-validate:required />
      <div id="captchaBox" class="btnWrap">
        <button type="button" class="btn" :disabled="verifyInvalid" :class="{'z-disabled': verifyInvalid}">{{verifyTxt}}</button>
      </div>
      <p class="tip" v-if="codeError">{{codeError}}</p>
    </div>
    <div class="item item-left">
      <label for="protocol" class="checkbox">
        <input type="checkbox" name="protocol" id="protocol" v-model="protocol" v-validate:required />
        <i class="icon-checkbox"></i>
        <i>我已阅读并同意<a href="/protocol/staff/" target="_blank">《用户注册协议》</a></i>
      </label>
    </div>
    <div class="item f-cf">
      <button type="submit" class="f-fl submitBtn" :disabled="formInvalid" @click.prevent="submit"
        data-action="saTrack"
        data-event="UnionLoginBtnClick"
        data-track-event-origin="web">确认登录</button>
      <p class="linkWrap f-fr"><a href="/backend/register/" @click.prevent="goRegister">立即注册</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/backend/reset/" @click.prevent="goReset">忘记密码？</a></p>
    </div>
  </form>
  <footer>
    <p class="divide">第三方账号登录</p>
    <a class="icn icn-weixin" :href="weixinUri"></a>
    <a class="icn icn-work-weixin" href="/partner/work-weixin/user/auth/"></a>
  </footer>
</div>
</template>

<script>
import LoginMixin from '@/mixins/login';
import VerifyMixin from '@/mixins/verify';
import LoginSvc from '@/services/login';
import MiniTabs from '@/components/mini_tabs/mini_tabs';
// import AnalysisSvc from '@/services/analysis';
import {
  Search2objFilter as search2obj,
  Obj2searchFilter as obj2search,
} from 'Russel';

export default {
  name: 'Login',
  data() {
    return {
      searchObj: search2obj(location.search),
      loginTypes: [
        { name: '密码登录', value: 'password' },
        { name: '验证码登录', value: 'code' },
      ],
      loginType: 'password',
      csrfToken: '',
    };
  },
  computed: {
    formInvalid() {
      switch (this.loginType) {
        case 'password': return this.getFormInvalid(['phone', 'password', 'protocol']);
        case 'code': return this.getFormInvalid(['phone', 'code', 'protocol']);
        default: return !1;
      }
    },
    isDev() {
      return !location.href.match(/^https?:\/\/(www\.|cloud\.)?qingchengfit\.cn.*$/);
    },
    appId() {
      return this.isDev ? 'wxf27c0fa3622acc79' : 'wx9ee866b4f96f8334';
    },
    redirectUri() {
      const query = {
        next: this.searchObj.next || this.config.next,
      };
      return `${location.protocol}//${this.isDev ? 'cloudtest' : 'cloud'}.qingchengfit.cn/api/web/wechat/callback/?${obj2search(query)}`;
    },
    weixinQuery() {
      return {
        appid: this.appId,
        redirectUri: this.redirectUri,
        response_type: 'code',
        scope: 'snsapi_login',
        state: this.csrfToken,
      };
    },
    weixinUri() {
      return `https://open.weixin.qq.com/connect/qrconnect?${obj2search(this.weixinQuery)}#wechat_redirect`;
    },
  },
  methods: {
    submit() {
      if (this.formInvalid || this.submitting) return !1;
      const data = {
        area_code: this.area,
        phone: this.phone,
        has_read_agreement: !0,
      };

      if (this.loginType === 'code') {
        data.code = this.code;
      } else {
        data.password = this.password;
      }

      this.submitting = !0;
      LoginSvc.login(this.config.loginReq, {}, data).then(() => {
        location.href = this.searchObj.next || this.config.next;
        this.submitting = !1;
      }).catch((msg) => {
        this.submitting = !1;
        alert(msg);
      });
      return !0;
    },
  },
  components: {
    MiniTabs,
  },
  mixins: [LoginMixin, VerifyMixin],
  created() {

  },
  mounted() {
    try {
      this.csrfToken = document.getElementsByName('csrfmiddlewaretoken')[0].value;
    } catch (e) {
      console.warn(e);
    }
    // AnalysisSvc.init();
  },
};
</script>

<style lang="less">
@import "../styles/modules/login.less";
</style>



// WEBPACK FOOTER //
// src/pages/login.vue